import { FC, PropsWithChildren } from "react";

export const SidebarBottomContent: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex min-h-fit flex-initial flex-col border-t border-foreground/10 px-3 py-3">
      <div className="flex flex-row justify-between gap-1.5">{children}</div>
    </div>
  );
};
